export const FEATURES_WHITELIST = {
  MARCH_MADNESS_2025: 'MARCH_MADNESS_2025',
  MARCH_MADNESS_2025_SUBMISSION: 'MARCH_MADNESS_2025_SUBMISSION',
  MARCH_MADNESS_2025_SUBMISSION_CLOSED: 'MARCH_MADNESS_2025_SUBMISSION_CLOSED',
};
